<template>
  <section class="filter-menu-section pt-0" id="myScrollspy">
    <div
      ref="deliveryArea"
      class="no-da-selected"
      v-if="!isModuleEnable(CONST.MODULE_WEBSITE) && domainBasedBrand"
    >
      {{ _T('This Website not serving order(s) these days.') }}
    </div>
    <div class="container" id="list-container" v-else-if="selectedDa">
      <div class="row">
        <div class="col-12">
          <div class="filter-menu">
            <ul class="filter-list">
              <scrollactive class="my-nav" :offset="200" highlightFirstItem>
                <template>
                  <a
                    href="#all"
                    :key="'offer_all'"
                    class="filter-link scrollactive-item"
                    @click="selectedOffer('all')"
                  >
                    <div v-if="customizationLocal.title_availability">
                      <!--<div class="svg">
                      <svg class="offer_svg" fill="none">
                        <use :xlink:href="'#offer-1'" />
                      </svg>
                    </div>-->
                      <h4>{{ _T('All') }}</h4>
                    </div>
                  </a>
                </template>
                <template v-for="(offer, key, index) in availableGoorderTypes">
                  <a
                    :href="getHref(offer.name)"
                    :key="'offer' + key"
                    class="filter-link scrollactive-item"
                    @click="selectedOffer(offer.name)"
                    v-if="offer.name"
                  >
                    <div>
                      <div class="svg">
                        <svg class="offer_svg" fill="none">
                          <use :xlink:href="'#offer-' + index" />
                        </svg>
                      </div>
                      <h4>{{ _T_DB(offer, 'name') }}</h4>
                    </div>
                  </a>
                </template>
              </scrollactive>
            </ul>
            <search-bar />
          </div>
        </div>
      </div>
    </div>
    <div
      ref="deliveryArea"
      class="no-da-selected"
      v-else-if="customerFullAddress"
    >
      {{ _T("Sorry, but we don't serve that location") }}
    </div>
    <div ref="deliveryArea" class="no-da-selected" v-else>
      {{ _T('Please select where you want your order to be delivered') }}
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
import SearchBar from '@/components/Blocks/SearchBar'
export default {
  name: 'offer',
  components: {
    SearchBar,
  },
  mixins: [Windowsize],
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'availableGoorderTypes',
      'customerFullAddress',
      'selectedDa',
      'web_user',
      'customizationLocal',
      'isModuleEnable',
      'domainBasedBrand',
    ]),
  },
  watch: {
    selectedDa: {
      immediate: true,
      handler() {
        // if (
        //   !val.length &&
        //   isObjectEmpty(this.availableGoorderTypes) &&
        //   this.windowSize < 575 &&
        //   this.$route.name.includes('home') &&
        //   !this.web_user
        // ) {
        //   document.body.style.setProperty('overflow-y', 'hidden')
        // } else {
        //   document.body.style.setProperty('overflow-y', 'auto')
        // }
        this.$nextTick(() => {
          this.addMinHeight()
        })
      },
    },
  },
  methods: {
    selectedOffer(data) {
      this.$store.commit('SET_SELECTED_GOORDER_TYPE', data)
    },
    filterBrands(event) {
      var term = event.target.value.toLowerCase()
      this.$store.commit('SET_SEARCH_TERM', term)
    },
    getHref(data) {
      return '#' + data.split(' ').join('')
    },
    addMinHeight() {
      let isIos = /iphone|ipod|ipad/.test(
        window.navigator.userAgent.toLowerCase()
      )
      if (!isIos || this.windowSize > 575) {
        return
      }
      if (this.$refs.deliveryArea) {
        const $styleRef = this.$refs.deliveryArea.style
        $styleRef.minHeight = `${this.windowHeight * 0.2 + 10}px`
        $styleRef.display = 'flex'
        $styleRef.alignItems = 'center'
        $styleRef.justifyContent = 'center'
      }
    },
  },
  mounted() {
    this.addMinHeight()
  },
}
</script>

<style lang="scss" scoped>
.filter-menu-section {
  position: sticky;
  z-index: 1;
  background-color: $white;
  top: $px84;
  #list-container {
    display: block !important;
    min-height: unset !important;
  }
  .no-da-selected {
    padding: 2rem;
    font-size: $px24;
    text-align: center;
    color: $color-primary;
    font-weight: 600;
  }
  .filter-menu {
    display: flex;
    border-bottom: $px1 solid $light-border;
    .filter-list {
      display: flex;
      .scrollactive-nav {
        display: flex;
        margin-bottom: -$px1;
        .filter-link {
          cursor: pointer;
          border-bottom: $px4 solid $transparent;
          transition: all 0.5s ease;
          display: flex;
          align-items: center;
          > div {
            display: flex;
            align-items: center;
            padding-bottom: $px15;
          }
          .svg {
            line-height: 1;
          }
          svg {
            fill: $font-color;
            margin-right: $px10;
            width: $px21;
          }
          h4 {
            color: $font-color;
            text-transform: capitalize;
            margin-bottom: 0;
            transition: all 0.5s ease;
          }
          + .filter-link {
            margin-left: $px30;
          }
          &.is-active {
            border-bottom: $px4 solid $color-primary;
            transition: all 0.5s ease;
            svg {
              fill: $color-primary;
              path {
                fill: $color-primary;
              }
            }
            h4 {
              color: $color-primary;
              transition: all 0.5s ease;
            }
          }
          &.accordion-toggle {
            position: relative;
            .more-option {
              position: absolute;
              background-color: $white;
              min-width: $px250;
              border-radius: $px4;
              border: $px1 solid $light-border;
              padding: $px20 $px16;
              box-shadow: 0 $px14 $px34 rgba($black, 0.1);
              left: -$px10;
              top: $px20;
              opacity: 0;
              visibility: hidden;
              transition: all 0.5s ease;
              z-index: 1;
              text-align: left;
              ul {
                li {
                  padding-bottom: 0;
                  border-bottom: none;
                  h4 {
                    transition: all 0.5s ease;
                    text-align: left;
                    color: $font-color;
                  }
                  + li {
                    margin-left: 0;
                  }
                  &.active {
                    h4 {
                      color: $color-primary;
                      transition: all 0.5s ease;
                    }
                  }
                  &:hover {
                    h4 {
                      color: $color-primary;
                      transition: all 0.5s ease;
                    }
                  }
                  &:first-child {
                    margin-top: -$px4;
                  }
                  &:last-child {
                    padding-bottom: 0;
                    h4 {
                      margin-bottom: -$px2;
                    }
                  }
                }
              }
              &.show {
                opacity: 1;
                visibility: visible;
                top: $px40;
                transition: all 0.5s ease;
              }
            }
          }
        }
      }
    }
    svg {
      height: $px20;
      width: $px22;
    }
  }
  &.inner-filter-menu {
    padding-top: $px20;
    padding-left: $px30;
    padding-bottom: $px35;
    position: relative;
    top: 0;
    z-index: -1;
    .filter-menu {
      .filter-list {
        li {
          + li {
            margin-left: $px55;
          }
        }
      }
    }
    .search-bar {
      padding-right: $px30;
    }
    &.fixed_top {
      position: fixed;
      width: 75%;
      flex: 0 0 75%;
      max-width: 75%;
      top: $px271;
      z-index: 1;
      padding: 0;
      .filter-menu {
        padding: 0 $px15 0;
      }
      .search-bar {
        .form-group {
          margin-bottom: $px10;
          margin-top: $px10;
          .form-control {
            border: $px1 solid $light-border;
          }
        }
      }
      &.sticky_up {
        top: $px131;
      }
    }
    &.filter-menu-sticky {
      position: fixed;
      left: 0;
      width: 100vw;
      top: $px159;
      z-index: 1;
      background-color: $white;
      border-top: $px1 solid $light-border;
      padding-bottom: 0;
    }
  }
  &.choose-menu-filter {
    padding-bottom: 0;
    top: $px99;
    z-index: 4;
    margin-bottom: $px30;
    .filter-menu {
      padding-top: $px20;
      .filter-list {
        li {
          padding-bottom: $px25;
          border-bottom: $px3 solid $transparent;
          &.active {
            border-bottom: $px3 solid $color-primary;
            h4 {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1240px) {
  .filter-menu-section {
    #list-container {
      display: block !important;
      min-height: unset !important;
    }
    .filter-menu {
      .filter-list {
        .scrollactive-nav {
          .filter-link {
            > div {
              padding-bottom: $px10;
            }
            + .filter-link {
              margin-left: $px20;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .filter-menu-section {
    #list-container {
      display: block !important;
      min-height: unset !important;
    }
    .filter-menu {
      .filter-list {
        .scrollactive-nav {
          .filter-link {
            > div {
              display: block;
              text-align: center;
            }
            .svg {
              margin-bottom: $px5;
            }
            h4 {
              font-size: $px16;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .filter-menu-section {
    #list-container {
      display: block !important;
      min-height: unset !important;
    }
    .filter-menu {
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      ::-webkit-scrollbar {
        width: 0 !important;
      }
      .filter-list {
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        padding-bottom: $px10;
        .scrollactive-nav {
          .filter-link {
            border-bottom: none;
            .svg {
              display: inline-block;
              padding: $px8;
              border: $px1 solid $light-border;
              border-radius: 100%;
              margin-bottom: $px5;
            }
            svg {
              margin-bottom: 0;
              margin-right: 0;
            }
            &.is-active {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .filter-menu-section {
    position: relative;
    top: 0;
    z-index: 0;
    #list-container {
      display: block !important;
      min-height: unset !important;
    }
    .filter-menu {
      display: grid;
      grid-template-columns: auto;
      .filter-list {
        .scrollactive-nav {
          .filter-link {
            h4 {
              font-size: $px14;
              line-height: $px22;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .filter-menu-section {
    padding-top: $px15;
    padding-bottom: 0;
    .no-da-selected {
      margin-bottom: $px120;
    }
    #list-container {
      display: block !important;
      min-height: unset !important;
    }
    .filter-menu {
      display: grid;
      grid-template-columns: auto;
      border-bottom: none;
      .filter-list {
        padding-bottom: 0;
        display: none !important;
        .scrollactive-nav {
          .filter-link {
            padding-bottom: 0;
            div {
              padding-bottom: 0;
            }
            h4 {
              font-size: $px11;
              line-height: $px18;
            }
            &.active {
              h4 {
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 420px) {
  .filter-menu-section {
    .no-da-selected {
      margin-bottom: $px90;
      font-size: $px20;
    }
  }
}
</style>
